import { Reveal } from "@/components/Reveal";
import { SectionParticles } from "@/components/SectionParticles";
import { SectionBg } from "@/components/SectionBg";

const TAKEAWAYS = [
  "VA Benefit-to-Keys Workbook",
  "Eligibility & Entitlement Question List",
  "Buying-Power & Cash Category Planner",
  "Optional Personalized Next-Step Review",
];

/* SECTION 10 — TAKEAWAYS */
export const Takeaways = () => (
  <section className="relative overflow-hidden px-5 md:px-10 lg:px-16 py-28 md:py-36 hairline-t" data-testid="takeaways-section">
    <SectionBg img="bg-home-1.jpg" strength={0.92} />
    <SectionParticles variant="circles" />
    <div className="relative z-10 max-w-6xl mx-auto text-left">
      <p className="font-mono text-[11px] tracking-[0.3em] text-[var(--muted)] mb-12">
        [007] — WHAT YOU WILL WALK AWAY WITH
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {TAKEAWAYS.map((t, i) => (
          <Reveal key={t} delay={i * 0.08}>
            <div
              data-testid={`takeaway-card-${i}`}
              className="h-full glass-panel rounded-[6px] p-7 hover:border-[rgba(148,222,82,0.4)] transition-colors duration-300"
            >
              <span aria-hidden="true" className="block w-8 h-8 rounded-[4px] bg-[rgba(148,222,82,0.12)] text-[var(--accent)] flex items-center justify-center text-sm mb-5">
                ✓
              </span>
              <p className="text-sm md:text-base font-medium leading-relaxed text-white">{t}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
